import { ThemeProvider as MUIThemeProvider } from "@mui/material";
import { ReactNode } from "react";
import { theme } from "./Theme";
import "./fonts.css";

interface Props {
  children: ReactNode;
}

export const ThemeProvider = ({ children }: Props) => {
  return <MUIThemeProvider theme={theme}>{children}</MUIThemeProvider>;
};
